import React from "react";
import { Row, Col, DataTable, DataTableColumn } from "@countysuite/ui";
import { DefaultEventTextRow } from "./DefaultEventTextStore";
import { observer } from "mobx-react";

export interface Props {
  rows: DefaultEventTextRow[];
  currentRow: DefaultEventTextRow;
  selectRow: (row: DefaultEventTextRow) => void;
}

export const DefaultEventTextTable: React.FC<Props> = observer(
  ({ rows, selectRow, currentRow }) => {
    const dtColumns: DataTableColumn<DefaultEventTextRow>[] = [
      {
        Header: "Name",
        accessor: "name",
        width: 200,
      },
      {
        Header: "Text",
        accessor: "defaultValue",
      },
    ];

    return (
      <Row>
        <Col xs={12}>
          <div className="full-width">
            <DataTable
              data={rows}
              columns={dtColumns}
              isRowSelected={(row: DefaultEventTextRow) =>
                row.id === currentRow.id
              }
              onRowClick={selectRow}
            />
          </div>
        </Col>
      </Row>
    );
  }
);
